import React from 'react';
import { CircularProgress, createStyles, Grid, makeStyles, Typography } from '@material-ui/core';

interface LoadingProps {
    nameFile: string,    
  }

const useStyles = makeStyles(() => createStyles({
    item: {
        margin: '24px',
        maxWidth: '730px',
        textAlign: 'center'
    }
}));

export function UploadLoading({nameFile}: LoadingProps) {
    const classes = useStyles();

    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="center">
            <Typography variant="h3" className={classes.item}>
                Sua planilha está sendo processada...
            </Typography>
            <Typography variant="body1" className={classes.item}> 
                Isso pode levar alguns minutos, por favor não recarregue ou feche a plataforma.
            </Typography>
            <CircularProgress
                color="primary"
                size="124px"
                className={classes.item}/>  
            <Typography variant="subtitle1" className={classes.item}>
                {nameFile}
            </Typography>          
        </Grid>
    );
}